import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext({ settings: null, homepage: {}, pages: {}, refresh: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const refresh = () => api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  useEffect(() => { refresh(); }, []);
  return <SettingsContext.Provider value={{ settings, homepage: settings?.homepage || {}, pages: settings?.pages || {}, refresh }}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext);
